import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["mode", "children", "sale", "disabled", "view", "onlyIcon", "loading", "invert", "iconLeftProps", "iconRightProps", "onlyIconProps"];
import React from 'react';
import { compose } from '@beef/utils';
import { withDataConverter } from '@beef/react';
import { cnBem } from '@carnica/utils';
import { MotionComponent } from "../../modules/MotionComponent";
import { ButtonIcon } from "./ButtonIcon";
import { ButtonSpinner } from "./ButtonSpinner";
import { dataConverter } from "./utils";
import styles from "./styles.pcss";
var cnButtonContent = cnBem('button-content', styles);
var ButtonRender = function ButtonRender(_ref, ref) {
  var _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'default' : _ref$mode,
    children = _ref.children,
    sale = _ref.sale,
    disabled = _ref.disabled,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'primary' : _ref$view,
    onlyIcon = _ref.onlyIcon,
    loading = _ref.loading,
    invert = _ref.invert,
    iconLeftProps = _ref.iconLeftProps,
    iconRightProps = _ref.iconRightProps,
    onlyIconProps = _ref.onlyIconProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MotionComponent, _extends({}, otherProps, {
    disabled: disabled,
    ref: ref,
    "data-t-id": "components-Button"
  }), loading && /*#__PURE__*/React.createElement(ButtonSpinner, {
    invert: invert,
    mode: mode,
    view: view
  }), onlyIcon ? /*#__PURE__*/React.createElement(ButtonIcon, onlyIconProps) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonIcon, _extends({
    className: cnButtonContent('icon', {
      position: 'left',
      mode: mode
    })
  }, iconLeftProps)), /*#__PURE__*/React.createElement(MotionComponent, {
    className: cnButtonContent('label'),
    tagName: mode === 'inline' ? 'span' : 'p'
  }, children, mode === 'default' && sale && /*#__PURE__*/React.createElement("span", {
    className: cnButtonContent('sale')
  }, sale)), /*#__PURE__*/React.createElement(ButtonIcon, _extends({
    className: cnButtonContent('icon', {
      position: 'right',
      mode: mode
    })
  }, iconRightProps))));
};
export var Button = compose(withDataConverter(dataConverter), React.forwardRef)(ButtonRender);